import { render } from "./MicrophoneOnIcon.vue?vue&type=template&id=01e9c9d0"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__